import { quickFlash } from '@/mocks/news';
import SectionHeading from '@/pages/home/components/SectionHeading';

export default function FlashSection() {
  return (
    <section id="flash" className="w-full bg-background-100 border-y border-background-200">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1200px] mx-auto py-12 md:py-16">
          <SectionHeading
            id="flash"
            kicker="新料快讯"
            title="按分钟排的新料快讯"
            desc="黑料网1新料快讯盯的是节奏：谁先出物料、谁改了档期、哪条回应先落地，都压进这条时间线。"
            actionHref="#hot"
            actionLabel="看热搜榜"
          />

          <ul className="mt-8 grid grid-cols-1 lg:grid-cols-2 gap-x-10">
            {quickFlash.map((item) => (
              <li key={`${item.time}-${item.title}`} className="border-b border-background-200">
                <a href="#flash" className="flex items-start gap-4 py-4 cursor-pointer group">
                  <span className="shrink-0 w-14 pt-0.5 font-heading text-sm font-bold text-primary-600 tracking-tight">
                    {item.time}
                  </span>
                  <span className="shrink-0 mt-0.5 h-6 px-2 inline-flex items-center rounded bg-background-50 border border-background-200 text-[11px] text-foreground-700">
                    {item.tag}
                  </span>
                  <span className="flex-1 text-sm md:text-[15px] text-foreground-900 leading-relaxed group-hover:text-primary-600 transition-colors">
                    {item.title}
                  </span>
                  <span className="shrink-0 w-6 h-6 flex items-center justify-center text-foreground-300 group-hover:text-primary-500 transition-colors">
                    <i className="ri-arrow-right-up-line text-base" aria-hidden="true"></i>
                  </span>
                </a>
              </li>
            ))}
          </ul>

          <div className="mt-8 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 rounded-lg bg-background-50 border border-background-200 px-5 py-4">
            <p className="text-sm text-foreground-700">
              黑料网1快讯每轮更新后自动补进时间线，页面保持本次浏览进度。
            </p>
            <a
              href="#top"
              className="inline-flex items-center justify-center gap-2 h-10 px-4 rounded-md bg-secondary-500 text-background-50 text-sm font-medium hover:bg-secondary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-refresh-line" aria-hidden="true"></i>
              回到顶部刷新
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}